module.exports = __webpack_public_path__ + "static/media/moons_advanced-375.d2bc4bcb.jpg";